import { render } from "./ManageUsers.vue?vue&type=template&id=5a944c80&scoped=true&ts=true"
import script from "./ManageUsers.vue?vue&type=script&lang=ts"
export * from "./ManageUsers.vue?vue&type=script&lang=ts"

import "./ManageUsers.vue?vue&type=style&index=0&id=5a944c80&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a944c80"]])

export default __exports__